import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Verify = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Email not provided. Please go back and register again.');
      return;
    }
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      //const response = await fetch('http://170.9.224.115:5000/auth/verify', {

const response = await fetch('/auth/verify', {


        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSuccess('Account verified! Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setError(data.message || 'Verification failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (!email) return;
    setLoading(true);
    try {
     // const response = await fetch('http://170.9.224.115:5000/auth/resend-verification', {

const response = await fetch('/auth/resend-verification', {

        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await response.json();
      if (response.ok) {
        alert('New verification code sent to your email.');
      } else {
        alert(data.message || 'Failed to resend code');
      }
    } catch (err) {
      alert('Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#111827',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#1f2937',
        padding: '40px',
        borderRadius: '12px',
        width: '100%',
        maxWidth: '400px',
        border: '2px solid #eab308'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ color: '#eab308', fontSize: '28px' }}>Verify Your Email</h1>
          <p style={{ color: '#9ca3af' }}>We sent a 6-digit code to {email || 'your email'}</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#9ca3af', fontSize: '12px', display: 'block', marginBottom: '5px' }}>VERIFICATION CODE</label>
            <input
              type="text"
              maxLength="6"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              placeholder="000000"
              required
              style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid #374151', backgroundColor: '#111827', color: 'white', fontSize: '24px', textAlign: 'center', letterSpacing: '8px' }}
            />
          </div>

          {error && <div style={{ backgroundColor: '#450a0a', color: '#ef4444', padding: '10px', borderRadius: '6px', marginBottom: '20px', textAlign: 'center' }}>{error}</div>}
          {success && <div style={{ backgroundColor: '#064e3b', color: '#10b981', padding: '10px', borderRadius: '6px', marginBottom: '20px', textAlign: 'center' }}>{success}</div>}

          <button
            type="submit"
            disabled={loading || code.length !== 6}
            style={{ width: '100%', padding: '12px', backgroundColor: code.length === 6 ? '#eab308' : '#6b7280', color: 'black', border: 'none', borderRadius: '6px', cursor: code.length === 6 ? 'pointer' : 'not-allowed', fontWeight: 'bold', fontSize: '16px' }}
          >
            {loading ? 'VERIFYING...' : 'VERIFY'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <p style={{ color: '#9ca3af', fontSize: '14px' }}>
            Didn't receive code?{' '}
            <span onClick={handleResend} style={{ color: '#eab308', cursor: 'pointer', textDecoration: 'underline' }}>Resend</span>
          </p>
          <p style={{ color: '#9ca3af', fontSize: '14px', marginTop: '10px' }}>
            <span onClick={() => navigate('/login')} style={{ color: '#eab308', cursor: 'pointer', textDecoration: 'underline' }}>Back to Login</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Verify;
